import { Component } from "@kluntje/core";
import { addClass, removeClass } from "@kluntje/js-utils/lib/dom-helpers";
import { isEdit } from "Helper/aemHelper";

export class FraTabbar extends Component {
  constructor() {
    super({
      ui: {
        items: ".fra-m-tabbar__list-item",
        activeItem: ".cmp-tabs__tab--active :-one",
      },
      events: [
        {
          event: "click",
          target: "items",
          handler: "handleItemClick",
        },
      ],
    });
  }

  /**
   * if component is edited in AEM environment, mutation observer is necessary to detect tab switch
   * @override
   */
  afterComponentRender(): void {
    if (isEdit()) {
      const classObserver = new MutationObserver(mutationList => {
        mutationList.forEach(mutation => {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "class" &&
            mutation.target.classList.contains("cmp-tabs__tab--active") &&
            (mutation.target as HTMLElement) !== this.ui.activeItem
          ) {
            const item = mutation.target as HTMLElement;
            this.ui.activeItem = item;
            item.scrollIntoView({ inline: "center", block: "nearest", behavior: "smooth" });
          }
        });
      });
      [...this.ui.items].forEach(item => classObserver.observe(item, { attributes: true }));
    } else if (window.location.hash) {
      const targetNode = [...this.ui.items].find(node => node.dataset.anchorId === window.location.hash.substring(1));
      if (targetNode) targetNode.click();
    }
  }

  /**
   * handles click on tab
   * @param {Event} e
   */
  handleItemClick(e: Event): void {
    const item = e.currentTarget as HTMLElement;
    removeClass(this.ui.activeItem, "cmp-tabs__tab--active");
    addClass(item, "cmp-tabs__tab--active");
    this.ui.activeItem = item;
    item.scrollIntoView({ inline: "center", block: "nearest" });
  }
}

customElements.define("fra-m-tabbar", FraTabbar);

export default FraTabbar;
